import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./ArticleStatistics.module.css";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CustomIcon from "components/icons/CustomIcon";
import Inline from "layouts/container/Inline";
import { useEffect, useState } from "react";
import { adminRequester, requester } from "App";
import { useNavigate } from "react-router-dom";

function ArticleStatistics() {
  const [mounted, setMounted] = useState(false);
  const [article, setArticle] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    adminRequester.getArticleStatus({ status: "now" }, (result) => {
      setArticle([
        {
          text: "공지사항",
          icon: <CustomIcon name={"notice"} color={"#383E58"} width={20} />,
          count: result.data.notification || 0,
        },
        {
          text: "QnA",
          icon: <CustomIcon name={"qna"} color={"#383E58"} width={20} />,
          count: result.data.QnA || 0,
        },
        {
          text: "리뷰",
          icon: <CustomIcon name={"review"} color={"#383E58"} width={20} />,
          count: result.data.review || 0,
        },
      ]);
    });
  }, [mounted]);

  const onClick = (e) => {
    
  };
  return (
    <div className={style.wrap}>
      <VerticalFlex gap={5}>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex padding={"0 10px"}>
              <FlexChild>
                <HorizontalFlex gap={5}>
                  <FlexChild width={"max-content"}>
                    <CustomIcon
                      name={"articleStatus"}
                      width={20}
                      color={"white"}
                    />
                  </FlexChild>
                  <FlexChild>
                    <Center width={"100%"} textAlign={"left"}>
                      <P color={"white"} weight={"bold"}>
                        게시물 현황
                      </P>
                    </Center>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <VerticalFlex>
                  <FlexChild>
                    <P
                      size={"14pt"}
                      color={"white"}
                      onClick={() => navigate("/admin/articleManagement")}
                    >
                      {">"}
                    </P>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.boxWrap}>
            <HorizontalFlex gap={10}>
              {article &&
                article.map((data, index) => (
                  <FlexChild key={index}>
                    <div className={style.boxArea}>
                      <VerticalFlex gap={10}>
                        <FlexChild>{data.icon}</FlexChild>
                        <FlexChild>
                          <Center>
                            <P onClick={onClick}>{data.text}</P>
                          </Center>
                        </FlexChild>
                      </VerticalFlex>
                      <div className={style.count}>
                        <Center>
                          <P>{data.count}</P>
                        </Center>
                      </div>
                    </div>
                  </FlexChild>
                ))}
            </HorizontalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default ArticleStatistics;
